import {
  CalendarJobPostingItemDto,
  CalendarPcItemDto,
  CalendarPcListDto,
  CalendarPcListRs,
} from '@domain/rs/calendar/CalendarPcListRs';
import { JobPostStatusType } from '@domain/constant/JobPostStatusType';

export type JobPostingBookmarkType = Map<number, boolean>;

export class CalendarPcListVO {
  calendarItems: CalendarPcListItemVO[];
  jobPostingBookmarkMap: JobPostingBookmarkType;

  constructor(dto: CalendarPcListRs) {
    this.calendarItems = dto.calendarItems.map((calendarItem) => new CalendarPcListItemVO(calendarItem));
    this.jobPostingBookmarkMap = this.getJobPostingBookmarkMap(dto);
  }

  private getJobPostingBookmarkMap(dto: CalendarPcListRs) {
    const map = new Map();
    dto.calendarItems.forEach((calendarItem) =>
      calendarItem.companies.forEach((company) =>
        company.jobPostings.forEach((jobPosting) => {
          map.set(jobPosting.sn, jobPosting.bookmarkYn);
        }),
      ),
    );
    return map;
  }
}

export class CalendarPcListItemVO {
  date: string;
  companies: CalendarPcItemVO[];

  constructor(dto: CalendarPcListDto) {
    this.date = dto.date;
    this.companies = dto.companies.map((company) => new CalendarPcItemVO(company));
  }
}

export class CalendarPcItemVO {
  companySn: number;
  companyName: string;
  statusType: JobPostStatusType;
  openingDateTime: string;
  closingDateTime: string;
  jobPostings: CalendarJobPostingItemVO[];

  constructor(dto: CalendarPcItemDto) {
    this.companySn = dto.companySn;
    this.companyName = dto.companyName;
    this.statusType = dto.statusType;
    this.openingDateTime = dto.openingDateTime;
    this.closingDateTime = dto.closingDateTime;
    this.jobPostings = dto.jobPostings.map(
      (jobPosting) =>
        new CalendarJobPostingItemVO(jobPosting, {
          companyName: dto.companyName,
          statusType: dto.statusType,
        }),
    );
  }
}

// 공고 모달을 위한 추가 데이터
export class AdditionalJobPostModalVO {
  companyName?: string;
  statusType?: JobPostStatusType;

  constructor(vo?: AdditionalJobPostModalVO) {
    this.companyName = vo?.companyName;
    this.statusType = vo?.statusType;
  }
}

export class CalendarJobPostingItemVO extends AdditionalJobPostModalVO {
  sn: number;
  name: string;
  openingDateTime: string;
  closingDateTime: string;
  bookmarkYn: boolean;
  aiScreeningYn: boolean;

  constructor(dto: CalendarJobPostingItemDto, vo?: AdditionalJobPostModalVO) {
    super(vo);
    this.sn = dto.sn;
    this.name = dto.name;
    this.openingDateTime = dto.openingDateTime;
    this.closingDateTime = dto.closingDateTime;
    this.bookmarkYn = dto.bookmarkYn;
    this.aiScreeningYn = dto.screeningType === 'AI_SCREENING';
  }
}
